/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type workAddQueryVariables = {};
export type workAddQueryResponse = {
    readonly me: {
        readonly id: string;
    } | null;
};
export type workAddQuery = {
    readonly response: workAddQueryResponse;
    readonly variables: workAddQueryVariables;
};



/*
query workAddQuery {
  me {
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "workAddQuery",
    "selections": (v0/*: any*/),
    "type": "Root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "workAddQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "8ee931a2cd4dcc7cd89047852efb081d",
    "id": null,
    "metadata": {},
    "name": "workAddQuery",
    "operationKind": "query",
    "text": "query workAddQuery {\n  me {\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '807777e7259c41d14dfb09320863784a';
export default node;
